import { Component, computed, effect, inject, input, Signal } from '@angular/core';
import { AlerteComponent } from '@shared/components/alerte/alerte.component';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmLabelImports } from '@spartan-ng/helm/label';

import { Interrelation } from '../../../référentiel-métier/référentiel-metier-interrelations/models/interrelation.model';
import { InterrelationStore } from '../../../référentiel-métier/référentiel-metier-interrelations/store/interrelation.store';
import { Aptitude } from '../../../référentiel-métier/référentiel-métier-processus/processus-aptitude/models/aptitude.model';
import { ActivitéFormService } from '../activité-form.service';

@Component({
  selector: 'app-interrelations',
  imports: [HlmFieldImports, HlmCheckboxImports, TrierParPipe, AlerteComponent, HlmLabelImports],
  templateUrl: './interrelations.component.html',
})
export class InterrelationsComponent {
  readonly #interrelationStore = inject(InterrelationStore);

  readonly formService = input.required<ActivitéFormService>();

  readonly form = computed(() => this.formService().form);
  readonly interrelations = computed(() =>
    this.#interrelationStore.entities().filter((x) => {
      const aptitudes: Aptitude[] = this.formService().aptitudePrincipaleAptitude.value
        ? [this.formService().aptitudePrincipaleAptitude.value, ...this.formService().aptitudesSecondaires.value]
        : [];
      return x.idsPhase?.filter((idPhase) => aptitudes.map((x) => x.idPhase).includes(idPhase)).length;
    }),
  );

  constructor() {
    effect(() => {
      const formService = this.formService();
      const aptitudes = this.formService().toutesLesAptitudes();

      const interrelations = (formService.interrelations.value as Interrelation[]).filter(
        (x) => x.idsPhase?.filter((idPhase) => aptitudes.map((x) => x.idPhase).includes(idPhase)).length,
      );
      formService.interrelations.setValue(interrelations, { emitEvent: false });
    });
  }

  onCheckboxChange(checked: boolean, item: Interrelation) {
    const formControl = this.formControl;
    const values = formControl.value;
    if (checked) {
      if (!values.map((v) => v.nom).includes(item.nom)) {
        formControl.setValue([...values, item]);
      }
    } else {
      const idxToDelete = values.findIndex((x) => x.id == item.id);
      if (idxToDelete > -1) {
        values.splice(idxToDelete, 1);
        formControl.setValue([...values]);
      }
    }
  }

  isChecked = (item: string) =>
    this.formControl.value.findIndex((x: { id: string; nom: string }) => x.id == item || x.nom == item) > -1;

  get formControl() {
    return this.formService().interrelations;
  }
}
